import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { VngDialogRef, VNG_DIALOG_DATA } from '@vengreso/angular-components';
import { Location } from '@angular/common';

import { SubscriptionPlanType } from 'src/app/core/models/stripe.models';
import { SUBSCRIPTION_TAB } from '../settings.config';

@Component({
    selector: 'app-downgraded',
    templateUrl: './downgraded.component.html',
    styleUrls: ['./downgraded.component.css'],
    standalone: false
})
export class DowngradedComponent implements OnInit, OnDestroy {

  planDowngradedTo: string = SubscriptionPlanType.Freemium;
  
  constructor(
    @Inject(VNG_DIALOG_DATA) public data : {planDowngradedTo : string},
    public dialogRef: VngDialogRef<DowngradedComponent>,
    private location: Location
  ) {
    this.planDowngradedTo = data.planDowngradedTo;
   }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.location.replaceState(`settings?tab=${SUBSCRIPTION_TAB}`);
  }

  close() {
    this.dialogRef.close();
  }

}
